import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import apiConstants from '../../constants/apiConstants';
import axios from 'axios';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "../../styles/MaterialUI";
import { showAlertPopup } from '../Redux/Features/showAlertSlice';

const MappedContentList = ({ selectedContents }) => {
    const { contentIds, contentStatus, modifiedStatus } = selectedContents;
    const { userToken } = useSelector((state) => state.userToken);
    const headers = { Authorization: `Bearer ${userToken}` };
    const [tableData, setTableData] = useState([]);
    const contentTypeMap = { "image": "Image", "video": "Video", "dashboard": "IntelliDash Dashboard", "content_playlist": "Content Playlist" };
    const dispatch = useDispatch();

    const groupBy = (data, key) => {
        return data.reduce((acc, item) => {
            (acc[item[key]] = acc[item[key]] || []).push(item);
            return acc;
        }, {});
    };

    const generateGroupedData = (data) => {
        const groupedByName = groupBy(data, 'content_name');
        return Object.keys(groupedByName).map(content_name => ({
            content_name,
            types: groupBy(groupedByName[content_name], 'content_type')
        }));
    };

    const getIntegrationData = async () => {
        try {
            const apiResponse = await axios.post(`${apiConstants.GET_API_URL}getIntegrations`, {}, { headers });
            const { data } = apiResponse.data;
            return data;
        } catch (error) {
            const { statusCode, message, redirect_url } = error.response.data;
            dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
            if (statusCode === 403) {
                window.open(redirect_url, "_self");
            }
        }
    }

    const getContents = async (contentIds) => {
        const payload = { content_ids: contentIds };
        try {
            const integrationData = await getIntegrationData();
            const response = await axios.post(`${apiConstants.GET_API_URL}getContentsByids`, payload, { headers });
            const { data } = response.data;

            data.forEach(item => {
                item.content_type = item.ic_org_integration_id ?
                    integrationData?.find(data => data.ic_org_integration_id === item.ic_org_integration_id).integration_name
                    : contentTypeMap[item.content_type];
                item.associated_screen = item.associated_screen === "N/A" ? "None" : item.associated_screen;
                item.associated_playlist = item.content_type !== "Content Playlist" && item.associated_playlist === "N/A" ? "None" : item.associated_playlist;
            });

            data.sort((a, b) => {
                if (a.content_name < b.content_name) return -1;
                if (a.content_name > b.content_name) return 1;
                if (a.content_type < b.content_type) return -1;
                if (a.content_type > b.content_type) return 1;
                return 0;
            });
            const updatedData = generateGroupedData(data);

            setTableData(updatedData);
        } catch (error) {
            const { statusCode, message, redirect_url } = error.response.data;
            dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
            if (statusCode === 403) {
                window.open(redirect_url, "_self");
            }
        }
    }

    useEffect(() => {
        getContents(contentIds);
    }, [contentIds]);

    const getContentStatus = () => {
        if (contentStatus === "delete") {
            return "Contents to be Deleted";
        }
        if (contentStatus && !modifiedStatus) {
            return "Contents to be Enabled";
        }
        if (modifiedStatus === "Enabled") {
            return "Contents to be Enabled";
        }
        return "Contents to be Disabled";
    };

    return (
        <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <TableContainer component={Paper} sx={{ maxHeight: "350px" }}>
                <Table size="small">
                    <TableHead sx={{ backgroundColor: "#003366", width: "100%", textWrap: "wrap", position: "sticky", top: 0, zIndex: 1 }}>
                        <TableRow>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>{getContentStatus()}</TableCell>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Content Type</TableCell>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Associated Screens</TableCell>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Content Mapped to Associated Screen by</TableCell>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Associated Content Playlist</TableCell>
                            <TableCell sx={{ color: "white", borderRight: '1px solid rgba(224, 224, 224, 1)' }}>Associated Playlist Created by</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((group, groupIndex) => (
                            <React.Fragment key={groupIndex}>
                                {Object.keys(group.types).map((type, typeIndex) => (
                                    <React.Fragment key={typeIndex}>
                                        {group.types[type].map((item, itemIndex) => (
                                            <TableRow key={itemIndex}>
                                                {typeIndex === 0 && itemIndex === 0 && (
                                                    <TableCell rowSpan={Object.keys(group.types).reduce((acc, curr) => acc + group.types[curr].length, 0)}
                                                        sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                                                        {group.content_name}
                                                    </TableCell>
                                                )}
                                                {itemIndex === 0 && (
                                                    <TableCell rowSpan={group.types[type].length} sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                                                        {type}
                                                    </TableCell>
                                                )}
                                                <TableCell sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>{item.associated_screen}</TableCell>
                                                <TableCell sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>{item.screen_mapper}</TableCell>
                                                <TableCell sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>{item.associated_playlist}</TableCell>
                                                <TableCell sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)' }}>{item.playlist_creator}</TableCell>
                                            </TableRow>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}

export default MappedContentList
